import type { AuthService } from "../../auth/services/auth.service";

type AnalyticsEventName =
  | "newsletter_signup" // OK
  | "newsletter_unsubscribe" // OK
  | "login" // OK
  | "search_bar_open" // OK
  | "search_bar_click" // OK
  | "news_agg_click" // OK
  | "report_download" // Not OK, need button vs. pdf iframe
  | "dashboard_tab_click" // OK
  | "graph_date_range_click" // OK
  | "delete_account" // Not Ok, need refactor account-management
  | "logout" // OK
  | "test" // OK
  | "invoice_click" // OK
  | "article_anchor_click" // OK
interface AnalyticsEventPayload {
  [key: string]: unknown;
}

interface AnalyticsEvent {
  name: AnalyticsEventName;
  payload: AnalyticsEventPayload;
}

interface AnalyticsContext {
  userId: string | null | undefined;
  companyId: string | null | undefined;
}

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
    gtag?: (...args: unknown[]) => void;
  }
}

export class AnalyticsService {
  public context: AnalyticsContext = { userId: undefined, companyId: undefined };
  private queue: AnalyticsEvent[] = [];
  private dataLayer: Array<Record<string, unknown>>;

  constructor(private readonly authService: AuthService) {
    this.dataLayer = window.dataLayer || [];
  }

  public setUserContext(): void {
    this.context = { userId: this.authService.profile.id ?? null, companyId: this.authService.profile.userCompany ?? null };

    this.dataLayer.push({
      user_id: this.context.userId ?? null,
      company_id: this.context.companyId ?? null,
      custom_user_id: this.context.userId ?? null,
    });
    
    this.flushQueue();
  }

  public clearUserContext(): void {
    this.context = { userId: null, companyId: null };
    this.queue = [];

    this.dataLayer.push({ user_id: null, company_id: null });
  }

  public track(eventName: AnalyticsEventName, payload: AnalyticsEventPayload = {}): void {
    const event: AnalyticsEvent = { name: eventName, payload };
    // this.setUserContext()
    this.pushToDataLayer(event);
  }

  public flushQueue(): void {
    while (this.queue.length > 0) {
      const event = this.queue.shift();
      if (event) {
        this.pushToDataLayer(event);
      }
    }
  }

  private pushToDataLayer(event: AnalyticsEvent): void {
    const dataLayerEvent = {
      event: event.name,
      ...event.payload,
    };

    this.dataLayer.push(dataLayerEvent);
  }
}